<template>
  <div>
    <div class="form-inline">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="版本类型">
            <el-select
              size="small"
              v-model="formInline.versionType"
              placeholder="请选择版本类型"
            >
              <el-option
                v-for="item in versionTypes"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号">
            <el-input
              size="small"
              v-model="formInline.version"
              placeholder="请输入版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="固件分区">
            <el-select
              size="small"
              v-model="formInline.firmArea"
              placeholder="请选择固件分区"
            >
              <el-option label="A" value="A"></el-option>
              <el-option label="B" value="B"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目">
            <el-select
              size="small"
              filterable
              v-model="formInline.projectId"
              v-el-select-loadmore="loadMore"
              placeholder="请选择所属项目"
            >
              <el-option
                v-for="item in project.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="success" plain @click="onQuery">查询</el-button>
            <el-button plain @click="onReset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button
        type="success"
        plain
        @click="handleAdd"
        v-if="hasPermission('ota.firm.add')"
        >新增固件</el-button
      >
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="firmId" label="固件ID" align="center" width="160">
      </el-table-column>
      <el-table-column
        prop="versionType"
        label="版本类型"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column prop="area" label="固件分区" align="center" width="80">
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="所属项目"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="文件名称"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="version"
        label="固件版本"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column prop="size" label="固件大小" align="center" width="80">
      </el-table-column>
      <!-- <el-table-column prop="md5" label="固件MD5" align="center" width="160">
      </el-table-column> -->
      <el-table-column prop="desc" label="固件描述" align="center" width="200">
      </el-table-column>

      <el-table-column
        prop="releaseNote"
        label="版本发布说明"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="固件状态"
        align="center"
        width="100"
        :filters="[
          { text: '未使用', value: '未使用' },
          { text: '使用中', value: '使用中' },
          { text: '低版本', value: '低版本' }
        ]"
        :filter-method="filterFirmStatus"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="
              {
                未使用: 'primary',
                使用中: 'success',
                低版本: 'danger'
              }[scope.row.status]
            "
            disable-transitions
            >{{ scope.row.status }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="creator" label="创建人" align="center" width="90">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="hasPermission('ota.firm.download')"
            type="success"
            size="mini"
            plain
            @click="handleDownload(scope.$index, scope.row)"
            >下载</el-button
          >
          <!-- <el-button
            type="primary"
            size="mini"
            plain
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          > -->
          <el-button
            v-if="hasPermission('ota.firm.delete')"
            size="mini"
            type="danger"
            plain
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNo"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="formInline.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Firmware",
  data() {
    return {
      versionTypes: [],
      project: {
        total: 0,
        list: [],
        pageNo: 1
      },
      tableData: [],
      formInline: {
        versionType: "",
        version: "",
        firmArea: "",
        projectId: "",
        pageNo: 1,
        pageSize: 5,
        total: 0
      }
    };
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          if (scrollHeight - scrollTop == clientHeight) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getVersionType() {
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/versionType",
        method: "GET",
        callback: response => {
          this.versionTypes = response;
        }
      });
    },
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));

          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    getFirmwareList() {
      const data = {
        versionType: this.formInline.versionType,
        version: this.formInline.version,
        firmArea: this.formInline.firmArea,
        projectId: this.formInline.projectId,
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/page",
        data: data,
        method: "GET",
        callback: response => {
          this.tableData = response.list;
          this.formInline.total = response.count;
          this.formInline.pageNo = response.pageNo;
          this.formInline.pageSize = response.pageSize;
        }
      });
    },
    filterFirmStatus(value, row) {
      return row.status === value;
    },
    handleDelete(index, row) {
      console.log(index, row);
      const data = {
        id: row.firmId
      };
      this.$confirm("确认删除该固件吗？") // 弹出确认框
        .then(() => {
          this.$store.dispatch("firmware/handleRequest", {
            url: "/battery/ota/firmDelete",
            data: data,
            method: "DELETE",
            callback: response => {
              this.$message.success("删除成功!");
              this.getFirmwareList(); // 刷新列表
            }
          });
        })
        .catch(() => {});
    },
    onQuery() {
      this.getFirmwareList();
    },
    handleAdd() {
      console.log("新增!");
      this.$router.push("./addFirmware");
    },
    handleCurrentChange(pageNo) {
      console.log("pageNo", pageNo);
      this.formInline.pageNo = pageNo;
      this.getFirmwareList(); // 刷新列表
    },

    handleSizeChange(pageSize) {
      this.formInline.pageSize = pageSize;
      this.getFirmwareList(); // 刷新列表
    },
    handleDownload(index, row) {
      console.log(index, row);
    },
    onReset() {
      this.formInline.versionType = "";
      this.formInline.version = "";
      this.formInline.firmArea = "";
      this.formInline.projectId = "";
    },
    hasPermission(permission) {
      if (!permission) {
        return true;
      }
      let flag = false;
      const menus = this.$store.state.login.menu;
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu == permission) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  },
  beforeMount() {
    // console.log("beforeMount!");
    this.getVersionType();
    this.getProjects(this.project.pageNo);
    this.getFirmwareList();
  } //生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.form-inline {
  border-bottom: 1px solid #dcdfe6;
}
.demo-form-inline {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
.btn-group {
  margin: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  /deep/ .el-pagination {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/otaManager/firmware.vue